<script setup lang="ts">
import { ref } from 'vue';
import { useMobilePreferences } from '@/composables/useMobilePreferences';
import MobileAccountMenu from './MobileAccountMenu.vue';

const { viewFullVersion } = useMobilePreferences();
const isMenuOpen = ref(false);
</script>

<template>
  <header
    class="flex shrink-0 items-center justify-between bg-shade-880 px-4 py-2 pt-[max(0.5rem,env(safe-area-inset-top))]"
    data-test="mobile-top-bar"
  >
    <img src="@/assets/svg/ff-logo.svg" alt="FactoryFix" width="27.43" height="24" />

    <button
      type="button"
      class="text-xs font-bold text-white"
      data-test="view-full-version"
      @click="viewFullVersion"
    >
      Show full version
    </button>

    <button
      type="button"
      class="-m-2.5 flex items-center justify-center p-2.5"
      :aria-label="isMenuOpen ? 'Close account menu' : 'Open account menu'"
      data-test="open-account-menu"
      @click="isMenuOpen = !isMenuOpen"
    >
      <img v-if="isMenuOpen" src="@/assets/svg/close-white.svg" alt="" width="24" height="24" />
      <img v-else src="@/assets/svg/menu.svg" alt="" width="24" height="24" />
    </button>
  </header>

  <!-- Top-anchored dropdown panel teleported to body; rendered as a sibling of the
       header so the overlay sits in a clean stacking context. -->
  <MobileAccountMenu v-model="isMenuOpen" />
</template>
